
import React from 'react';
import PropTypes from 'prop-types';

import restrictNumber from '../../../../utils/restrictNumber';
import {
  StyledOptionField,
  StyledOptionSliderSlot,
  StyledSpacedOptionFields,
} from '../../../../components/common/AnnotationOptions/AnnotationOptions.styled';
import Slider from '../../../../components/common/Slider';

const MIN_VALUE = 0;
const MAX_VALUE = 15;
const SLIDER_STEP = 1;
const POPUP_SLIDER_WIDTH = '100%';

const LetterSpacingField = ({
  annotation: text,
  updateAnnotation: updateText,
  t,
}) => {
  const { letterSpacing } = text;

  const letterSpacingValue =
    letterSpacing === undefined || letterSpacing === null
      ? MIN_VALUE
      : letterSpacing;

  return (
    <StyledSpacedOptionFields className="respark_annotation-option-panel respark_text-spacing-option-panel">
      <StyledOptionField>
        <StyledOptionSliderSlot>
          <Slider
            width={POPUP_SLIDER_WIDTH}
            annotation=" px"
            onChange={(val) =>
              updateText({
                letterSpacing: restrictNumber(val, MIN_VALUE, MAX_VALUE),
              })
            }
            value={letterSpacingValue}
            step={SLIDER_STEP}
            min={MIN_VALUE}
            max={MAX_VALUE}
          />
        </StyledOptionSliderSlot>
      </StyledOptionField>
    </StyledSpacedOptionFields>
  );
};

LetterSpacingField.propTypes = {
  annotation: PropTypes.instanceOf(Object).isRequired,
  updateAnnotation: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default LetterSpacingField;
